import { type ViewItemEvent, viewItemEventSchema } from './eCommerceTrackingEventSchema';
import logger from '../logger';

export type ViewItemEventProps = Omit<ViewItemEvent, 'event_name' | 'event'>;

export const buildViewItemEvent = (props: ViewItemEventProps): ViewItemEvent => {
  const {
    anonymousId,
    authenticatedId,
    ecommerce: { currency, value, item_list_id, item_list_name, items }
  } = props;

  const viewItemEvent: ViewItemEvent = {
    event: 'ga4_event_ecommerce',
    event_name: 'view_item',
    anonymousId,
    authenticatedId,
    ecommerce: {
      currency,
      value,
      ...(item_list_id ? { item_list_id } : {}),
      ...(item_list_name ? { item_list_name } : {}),
      items
    }
  };

  const result = viewItemEventSchema.safeParse(viewItemEvent);

  if (!result.success) {
    logger.error(result.error, 'Invalid view item event');
  }

  return viewItemEvent;
};
